const Auth = {
  state: {
    currentUser: null,
    session: null,
    initialized: false,
    isTokenInvalid: false
  },

  getters: {
    getCurrentUser(state) {
      return state.currentUser;
    },

    getSession(state) {
      return state.session;
    },

    getAppToken(state) {
      return state.session?.accessToken?.jwtToken;
    },

    /**
     * Federated identities linked to the signed-in Cognito account.
     *
     * Cognito serialises this claim as an array in the ID token but as a JSON
     * string in the admin API, and some sessions in this app are built without a
     * decoded payload at all, so every shape is normalised to an array here.
     */
    getIdentities(state) {
      const identities = state.session?.idToken?.payload?.identities;

      if (!identities) {
        return [];
      }

      if (Array.isArray(identities)) {
        return identities;
      }

      try {
        const parsed = JSON.parse(identities);

        return Array.isArray(parsed) ? parsed : [parsed];
      } catch (error) {
        return [];
      }
    },

    getRefreshToken(state) {
      console.log('[Auth.js] getRefreshToken:', state.session);

      return state.session?.refreshToken?.token;
    },

    getInitialized(state) {
      return state.initialized;
    },

    isAuthenticated(state) {
      return state.currentUser !== null && state.session !== null;
    },

    getExpireDateAppToken(state) {
      return new Date(state.session?.accessToken?.payload?.exp * 1000);
    },

    isTokenExpired(state) {
      const expireDate = Auth.getters.getExpireDateAppToken(state);
      const currentDate = new Date();

      return expireDate ? expireDate < currentDate : false;
    },

    getIsTokenInvalid(state) {
      return state.isTokenInvalid;
    }
  }
};

export default Auth;
